import React from 'react'
import env from './../../../environments/environment'
import './teamLogoImage.scss'

export const teamLogoImage = EliteAgencyTeam => {
  if (!EliteAgencyTeam?.get('team_logo')) return <></>

  return (
    <div className='elite-agency-team-logo-container'>
      <div className='img-wrapper'>
        <div>
          <div className='elite-agency-team-img-wrapper'>
            <img
              src={`https://firebasestorage.googleapis.com/v0/b/${
                env.integrations.firebase.config.storageBucket
              }/o/${encodeURIComponent(decodeURIComponent(EliteAgencyTeam.get('team_logo')))}?alt=media`}
              alt={`${EliteAgencyTeam.get('team_name')} Team Logo`}
              className='mx-auto d-block elite-agency-team-logo-img'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
